"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataToBlobUrl = void 0;
function dataToBlobUrl(data, type) {
    const options = type ? { type } : undefined;
    const blob = new Blob([data], options);
    return URL.createObjectURL(blob);
}
exports.dataToBlobUrl = dataToBlobUrl;
